import type { BreakpointSize } from '../../styles';

export enum MediaType {
  Jpg = 'image/jpeg',
  Png = 'image/png',
  Gif = 'image/gif',
  Webp = 'image/webp',
  Svg = 'image/svg+xml',
  Jp2 = 'image/jp2',
}

export interface ImageSources {
  webP?: string;
  jpg?: string;
  png?: string;
  jp2?: string;
}

export interface MobileAndDesktopSources {
  mobileSources: ImageSources;
  desktopSources: ImageSources;
}

export interface PictureSources {
  src: string;
  type: string;
  media: string;
}

export type SourcesByBreakpoint = Partial<Record<BreakpointSize, ImageSources>>;

export type ResponsivePictureSources =
  | MobileAndDesktopSources
  | SourcesByBreakpoint;
